import { Query, TenantRegistrationInfo } from 'graphql/generated/graphqlTypes';

export function mockedGetTenantRegistrationInfoData(
  getTenantRegistrationInfo: TenantRegistrationInfo
): Pick<Query, 'getTenantRegistrationInfo'> {
  return {
    getTenantRegistrationInfo
  };
}

export const mockedGetTenantRegistrationInfoDataForQuery = mockedGetTenantRegistrationInfoData({
  __typename: 'TenantRegistrationInfo',
  tenantId: 'mockedTenantId',
  azureTenantId: 'mockedAzureTenantId',
  entraAdminConsentUrl: 'mockedEntraAdminConsentUrl'
});
